import React, { type ReactNode, createContext, useContext, useState } from 'react';
import { type Factory } from '@wix/web-bi-logger/dist/src/logger';
import { getSiteCurrencyForBiFromViewerModel } from '@wix/cashier-common/dist/src/utils/getSiteCurrencyFromViewerModel';
import { type WidgetMeta } from '../../../types/WidgetProps';
import { BiLogger } from './BiLogger';

export const BiLoggerContext = createContext<BiLogger>(null);

export interface Props {
  biLoggerFactory: Factory;
  meta: WidgetMeta;
  sessionId: string;
  requestShipping: boolean;
  children: ReactNode;
}

export const BiLoggerProvider = (props: Props) => {
  const [biLogger] = useState(() => {
    const biLoggerInstance = new BiLogger(props.biLoggerFactory.logger());

    biLoggerInstance.init({
      appId: props.meta.appDefId,
      msid: props.meta.siteId,
      visitorId: props.meta.visitorId,
      sessionId: props.sessionId,
      widgetId: props.meta.consumerWidgetId,
      requestShipping: props.requestShipping,
      siteCurrency: getSiteCurrencyForBiFromViewerModel(),
      checkoutSessionId: props.sessionId,
    });

    return biLoggerInstance;
  });

  return <BiLoggerContext.Provider value={biLogger}>{props.children}</BiLoggerContext.Provider>;
};

export const useBiLogger = () => useContext<BiLogger>(BiLoggerContext);
